import script from "./ViewQuestionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewQuestionsView.vue?vue&type=script&setup=true&lang=ts"

import "./ViewQuestionsView.vue?vue&type=style&index=0&id=7ed0e66b&lang=css"

const __exports__ = script;

export default __exports__